import {
    Button,
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow,
    TableCellLayout,
    TableColumnDefinition,
} from '@fluentui/react-components';
import { DeleteRegular } from '@fluentui/react-icons';
import { MpmProject } from '../../types/MpmTypes';
import { formatIsoDate } from '../../utils/dateFormatUtils';

type MpmProjectsTableProps = {
    projects: MpmProject[];
    onRemove: (index: number) => void;
};

const MpmProjectsTable = ({ projects, onRemove }: MpmProjectsTableProps) => {
    if (projects.length === 0) return null;

    const columns: TableColumnDefinition<MpmProject>[] = [
        createTableColumn<MpmProject>({
            columnId: 'templateName',
            renderHeaderCell: () => 'Template',
            renderCell: (item) => <TableCellLayout>{item.templateName}</TableCellLayout>,
        }),
        createTableColumn<MpmProject>({
            columnId: 'projectName',
            renderHeaderCell: () => 'Project Name',
            renderCell: (item) => <TableCellLayout>{item.projectName}</TableCellLayout>,
        }),
        createTableColumn<MpmProject>({
            columnId: 'billingDescription',
            renderHeaderCell: () => 'Billing Description',
            renderCell: (item) => <TableCellLayout truncate>{item.billingDescription}</TableCellLayout>,
        }),
        createTableColumn<MpmProject>({
            columnId: 'projectOwnerName',
            renderHeaderCell: () => 'Owner',
            renderCell: (item) => <TableCellLayout>{item.projectOwnerName}</TableCellLayout>,
        }),
        createTableColumn<MpmProject>({
            columnId: 'coverageStart',
            renderHeaderCell: () => 'Coverage Start',
            renderCell: (item) => <TableCellLayout>{formatIsoDate(item.coverageStart)}</TableCellLayout>,
        }),
        createTableColumn<MpmProject>({
            columnId: 'coverageEnd',
            renderHeaderCell: () => 'Coverage End',
            renderCell: (item) => <TableCellLayout>{formatIsoDate(item.coverageEnd)}</TableCellLayout>,
        }),
        createTableColumn<MpmProject>({
            columnId: 'projectStart',
            renderHeaderCell: () => 'Project Start',
            renderCell: (item) => <TableCellLayout>{formatIsoDate(item.projectStart)}</TableCellLayout>,
        }),
        createTableColumn<MpmProject>({
            columnId: 'actions',
            renderHeaderCell: () => '',
            renderCell: (item) => (
                <Button
                    appearance="subtle"
                    icon={<DeleteRegular />}
                    onClick={() => onRemove(projects.indexOf(item))}
                    aria-label="Remove project"
                />
            ),
        }),
    ];

    return (
        <DataGrid items={projects} columns={columns} style={{ width: '100%' }}>
            <DataGridHeader>
                <DataGridRow>
                    {({ renderHeaderCell }) => <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>}
                </DataGridRow>
            </DataGridHeader>
            <DataGridBody<MpmProject>>
                {({ item, rowId }) => (
                    <DataGridRow<MpmProject> key={rowId}>
                        {({ renderCell }) => <DataGridCell>{renderCell(item)}</DataGridCell>}
                    </DataGridRow>
                )}
            </DataGridBody>
        </DataGrid>
    );
};

export default MpmProjectsTable;
